import isEmpty from "ramda/es/isEmpty";
import pick from "ramda/es/pick";
import pluck from "ramda/es/pluck";
import defaultToEmptyObject from "ramda-extension/es/defaultToEmptyObject";
import rejectNil from "ramda-extension/es/rejectNil";
export const extractVersionResults = (beEndpointMappingArray, cache, parseResponse)=>{
    const cacheKeys = pluck('name', beEndpointMappingArray);
    const keyCaches = pick(cacheKeys, defaultToEmptyObject(cache.cache));
    if (isEmpty(keyCaches)) return [];
    return rejectNil(cacheKeys.map((name)=>keyCaches[name] ? {
            name,
            version: parseResponse(keyCaches?.[name].data.body)
        } : null));
};
